import React, { useState, useRef } from 'react';
import { Box } from '../Box/Box.js';

function FileUploader({ accept = '.png,.jpg,.pdf', children, multiple = false, onChange, }) {
    const [fileArray, setFileArray] = useState(null);
    const hiddenInput = useRef();
    const dragAndDropZone = useRef();
    const onUploadFiles = (e) => {
        e.preventDefault();
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        setFileArray(files);
        if (onChange)
            onChange(files);
    };
    return (React.createElement(Box, { ref: dragAndDropZone, onDrop: (e) => onUploadFiles(e), onDragOver: (e) => e.preventDefault() },
        React.createElement("input", { ref: hiddenInput, "data-testid": "file-uploader", type: "file", name: "img", accept: accept, multiple: multiple, hidden: true, onChange: (e) => onUploadFiles(e) }),
        React.createElement(children, {
            onClick: () => hiddenInput.current.click(),
            hasFiles: !!(fileArray === null || fileArray === void 0 ? void 0 : fileArray.length),
        })));
}

export { FileUploader as default };
